export const slugify = (value = "", fallback = "service") => {
  const source = String(value ?? "").trim().toLowerCase();
  const normalized = source
    .normalize("NFKD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/(^-|-$)/g, "");

  return normalized || fallback;
};

export const getServiceSlug = (service, localizeText = (value) => value) => {
  const explicitSlug = slugify(
    typeof service?.slug === "string" ? service.slug : "",
    "",
  );
  if (explicitSlug) {
    return explicitSlug;
  }

  const localizedTitle = localizeText(service?.title);
  const fallback = `service-${Number(service?.id) || 1}`;
  return slugify(localizedTitle, fallback);
};

